import { createFileRoute } from '@tanstack/react-router';
import StaysDetail from '../../components/webdesigned/StaysDetail';
import WebDesignedPortal from '../../components/portals/WebDesignedPortal';

export const Route = createFileRoute('/webdesigned/stays_/$id')({
  component: () => (
    <WebDesignedPortal>
      <StaysDetail />
    </WebDesignedPortal>
  ),
});
